import { Link } from "react-router";

import { ROUTES } from "@/app/routes";
import { ErrorState } from "@/components/common/EmptyState";
import { Loader } from "@/components/common/Loader";
import { StatCard } from "@/components/common/StatCard";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/ui/page-header";
import { useCurrency } from "@/features/accounts/hooks/useCurrency";
import { RecentSales } from "@/features/dashboard/components/RecentSales";
import { RevenueChart } from "@/features/dashboard/components/RevenueChart";
import { StockAlerts } from "@/features/dashboard/components/StockAlerts";
import { useDashboard } from "@/features/dashboard/hooks/useDashboard";
import { useCurrentOrganization } from "@/features/organization/hooks/useOrganization";
import { currencySymbol, formatAmount, plural } from "@/lib/format";

export default function DashboardPage() {
  const { currency } = useCurrency();
  const { organization } = useCurrentOrganization();
  const { today, stockValue, revenueSeries, alerts, recentSales, isLoading, error, refresh } = useDashboard();

  if (isLoading) return <Loader />;
  if (error) return <ErrorState message={error} onRetry={() => refresh()} />;

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Tableau de bord"
        subtitle="Votre activité du jour"
        action={
          <Button asChild>
            <Link to={ROUTES.vending}>Encaisser une vente</Link>
          </Button>
        }
      />

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <StatCard
          label="Recette du jour"
          value={formatAmount(today.revenue, currency)}
          unit={currencySymbol(currency)}
        />
        <StatCard label="Ventes du jour" value={String(today.saleCount)} unit={plural(today.saleCount, "vente")} />
        <StatCard
          label="Stock marchand"
          value={formatAmount(stockValue.product, currency)}
          unit={currencySymbol(currency)}
          hint="Prêt à vendre"
        />
        <StatCard
          label="Stock provisionnel"
          value={formatAmount(stockValue.provision, currency)}
          unit={currencySymbol(currency)}
          hint="Matières premières"
        />
      </div>

      <RevenueChart series={revenueSeries} currency={currency} />

      <div className="grid gap-4 lg:grid-cols-2">
        <StockAlerts alerts={alerts} />
        <RecentSales sales={recentSales} currency={currency} />
      </div>
    </div>
  );
}
